import { returnPath } from '~/features/common/utils/navigation/returnPath';


export const getIndexPath = returnPath("/templates/session-debrief");
export const getIdPath = returnPath("/templates/session-debrief/:id");